import React, {useEffect, useState} from "react";
import Constants from "../utils/Constants";
import { Paper } from '@mui/material'
import {Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import { Button, Typography, makeStyles } from "@material-ui/core";
import Grid from '@mui/material/Unstable_Grid2';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import {getAccessToken} from "../utils/Auth";
import axios from "axios";
import Notification from "./Notification";
import {formatDate, getDetail, getStaticFileUrls, isHidden} from "../utils/Functions";
import {Stack} from "@mui/material";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import ColumnsDialog from "./ColumnsDialog";

const http_str = "https://"
const versions_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/versions')


const useStyles = makeStyles(theme => ({
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        '& .MuiFormLabel-root.Mui-disabled': {
            color: 'red',
        },
        '& .MuiPaper-root': {
            backgroundColor: '#333333',
        }
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#1be01e',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#5861fc',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#fc0d31',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWidget: {
        margin: '5px',
        color: '#CCCCCC',
        justify: 'flex',
        alignItems: 'center',
    },
    inputRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        verticalAlign: 'baseline',
    },
    accordian: {
        color: '#EEE',
        justifyContent: "unset",
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

let headers = [
    { field: 'module', headerName: 'Module', width: 100, hidden: true },
    { field: 'version', headerName: 'Version', width: 200, hidden: false },
    { field: 'download_url', headerName: '', width: 50, hidden: false },
]

export default function DeployDialogSynology({ open, onClose, item }) {
    const classes = useStyles()
    const [columnsMode, setColumnsMode] = useState(false)
    const [versions, setVersions] = useState([])

    let title = 'Deploy Synology ' + item?.pk

    const getVersions = async () => {
        console.log("get versions for item: " + JSON.stringify(item))
        const params = "?platform=synology&module=responder"
        let url = versions_url + params
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                const items = res.data['versions'];
                for (let i = 0; i < items.length; i++) {
                    if (i === 0) {
                        items[i].version_str = items[i].major + "." + items[i].minor + "." + items[i].build + " (latest)"
                    }
                    else {
                        items[i].version_str = items[i].major + "." + items[i].minor + "." + items[i].build
                    }
                    const updateDownloadUrl = function(url) {
                        items[i].downloadUrl = url;
                        console.log("updated url: " + url)
                    }
                    let resp = getStaticFileUrls(items[i].filename, updateDownloadUrl, "source=global")
                }
                console.log(items);
                setVersions(items)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
                return Promise.reject(err);
            })
    }

    const handleOpenColumns = () => {
        setColumnsMode(true);
    };

    const handleCloseColumns = () => {
        setColumnsMode(false);
    };

    const toggleColumn = (event) => {
        for (let i = 0; i < headers.length; i++) {
            if (headers[i]['field'] === event.target.id) {
                headers[i]['hidden'] = !headers[i]['hidden']
            }
        }
        //  ugly but since the checkboxes aren't tied to state, they are tied to column definitions, they don't update
        //forceUpdate()
    };

    useEffect(() => {
        getVersions()
    }, []);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            // id={item?.pk}
            sx={{
                width: 500
              }}
            fullWidth={true}
            maxWidth = "sm"
        >
            <DialogTitle className={classes.dialogTitleBar}>{title}</DialogTitle>
            <DialogContent className={classes.dialog}>
                <DialogContentText className={classes.dialog} component={'span'}>
                    <Grid container spacing={2}>
                        <Grid item xs={11} className={classes.inputRow}>
                            <Typography className={classes.dialog} component={'span'}>
                                <Paper className={classes.card} variant="outlined" style={{padding: '15px'}}>
                                    <Stack direction={"row"} justifyContent={"space-between"}>
                                        <Typography variant="h4">Downloads</Typography>
                                        <Box>
                                            <ViewWeekOutlinedIcon className={classes.spaced} color={"primary"}
                                                                  onClick={() => handleOpenColumns()}/>
                                        </Box>
                                    </Stack>
                                    {/* TABLE */}
                                    <table className={classes.tableComponent} style={{width: 100 + "%"}}>
                                        <thead>
                                        <tr key={1} className={classes.tableComponent}>
                                            {headers.map(header => (
                                                <th width={header.width}
                                                    className={header.hidden === true ? classes.hide : ''}>{header.headerName}</th>
                                            ))}
                                        </tr>
                                        </thead>
                                        <tbody className={classes.tableComponent}>
                                        {versions.map(val =>
                                            <tr key={val.pk}
                                                bgcolor={'#222222'} className={classes.tableComponent}>
                                                <td className={isHidden('module', headers) ?  classes.hide : classes.tableCell}>{val.module}</td>
                                                <td className={isHidden('version', headers) ?  classes.hide : classes.tableCell}>{val.version_str}</td>
                                                <td className={isHidden('download_url', headers) ? classes.hide : classes.clickableTableCell}>
                                                    <CloudDownloadOutlinedIcon color={"primary"} onClick={(e) => window.open(val.downloadUrl, '_blank', 'noopener,noreferrer')}/></td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </Paper>
                                For detailed installation instructions:
                                <div><a href='https://support.ransomstop.com/portal/en/kb/articles/configure-an-analyzer' target="_blank" rel="noreferrer">Instructions To Install RansomStop</a></div>
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContentText>
                <DialogActions>
                    <Button className={classes.dialogNeutral} onClick={() => onClose()} variant="contained" startIcon={<DisabledByDefaultOutlinedIcon />}>CLOSE</Button>
                </DialogActions>
                {/* DIALOGS */}
                {/* COLUMNS DIALOG */}
                <ColumnsDialog
                    variant={"outlined"}
                    open={columnsMode}
                    onClose={handleCloseColumns}
                    onChange={toggleColumn}
                    headers={headers}
                />
            </DialogContent>
        </Dialog>
    )
}

